/**
 * D1 (#36): the ± range dictionary is a hardcoded, frontend-only option list —
 * no DB table, no dictionary endpoint. D6: PL "Okno wizyty" / EN "Visit window".
 */
export const WINDOW_RANGE_OPTIONS = [1, 2, 3, 4, 5, 7, 14] as const;

export type WindowRangeOption = (typeof WINDOW_RANGE_OPTIONS)[number];

export type WindowModeLang = 'pl' | 'en';

export interface WindowModeMessages {
  dialogTitle: string;
  dialogSubtitle: string;
  modesHeading: string;
  addMode: string;
  editMode: string;
  close: string;
  cancel: string;
  save: string;
  saving: string;
  label: string;
  labelPlaceholder: string;
  labelRequired: string;
  defaultMode: string;
  hasRange: string;
  noRange: string;
  mid: string;
  midInvalid: string;
  range: string;
  rangePick: string;
  rangeInvalid: string;
  exactlyOneDefault: string;
  noModes: string;
  defaultBadge: string;
  unknownError: string;
}

const pl: WindowModeMessages = {
  dialogTitle: 'Okno wizyty',
  dialogSubtitle: 'Tryby okna: etykieta, środek MID i zakres ±. Dokładnie jeden tryb jest domyślny.',
  modesHeading: 'Tryby okna',
  addMode: 'Dodaj tryb',
  editMode: 'Edytuj tryb',
  close: 'Zamknij',
  cancel: 'Anuluj',
  save: 'Zapisz tryb',
  saving: 'Zapisywanie…',
  label: 'Etykieta',
  labelPlaceholder: 'np. Q4W – wizyty co 4 tygodnie',
  labelRequired: 'Etykieta jest wymagana',
  defaultMode: 'Tryb domyślny',
  hasRange: 'Tryb ma zakres',
  noRange: 'bez zakresu',
  mid: 'Środek (MID)',
  midInvalid: 'Podaj całkowitą liczbę dni (np. 0, 28)',
  range: 'Zakres ±',
  rangePick: 'Wybierz zakres',
  rangeInvalid: 'Wybierz zakres z listy ±',
  exactlyOneDefault: 'Dokładnie jeden tryb okna musi być domyślny',
  noModes: 'Brak trybów okna',
  defaultBadge: 'domyślny',
  unknownError: 'Nie udało się zapisać trybu okna.',
};

const en: WindowModeMessages = {
  dialogTitle: 'Visit window',
  dialogSubtitle: 'Window modes: label, center MID and ± range. Exactly one mode is the default.',
  modesHeading: 'Window modes',
  addMode: 'Add mode',
  editMode: 'Edit mode',
  close: 'Close',
  cancel: 'Cancel',
  save: 'Save mode',
  saving: 'Saving…',
  label: 'Label',
  labelPlaceholder: 'e.g. Q4W – visits every 4 weeks',
  labelRequired: 'Label is required',
  defaultMode: 'Default mode',
  hasRange: 'Mode has a range',
  noRange: 'no range',
  mid: 'Center (MID)',
  midInvalid: 'Enter a whole day count (e.g. 0, 28)',
  range: 'Range ±',
  rangePick: 'Pick a range',
  rangeInvalid: 'Pick a range from the ± list',
  exactlyOneDefault: 'Exactly one window mode must be the default',
  noModes: 'No window modes',
  defaultBadge: 'default',
  unknownError: 'Could not save the window mode.',
};

export function windowModeTexts(lang: WindowModeLang): WindowModeMessages {
  return lang === 'en' ? en : pl;
}